import { type FC, useEffect, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Button, Input } from 'base-ui'

import { useMarketplacePartnerRegisterPageContext } from '../../marketplacePartnerRegisterPageContext'

const generateKey = (prefix: string, index: number): string => {
  return `${prefix}-${index}`
}
export const MarketplacePartnerRegisterPageFormBrandsAdder: FC = () => {
  const intl = useIntl()
  const { formState } = useMarketplacePartnerRegisterPageContext()
  const [brands, setBrands] = useState<string[]>([''])
  formState.use()

  useEffect(() => {
    const meaningful = brands.filter((brand) => brand.trim() !== '')

    const prev = formState.model.brands
    const sameLength = meaningful.length === prev.length
    const isSame =
      sameLength && meaningful.every((val, idx) => val === prev[idx])

    if (!isSame) {
      formState.setValue(meaningful, formState.model, 'brands')
    }
  }, [formState, brands, formState.model.brands])

  const handleBrandChange = (brandIndex: number, value: string): void => {
    setBrands((prevBrands) =>
      prevBrands.map((brand, index) => (index === brandIndex ? value : brand)),
    )
  }

  const handleAddMore = (): void => {
    setBrands((prevBrands) => [...prevBrands, ''])
  }

  const handleDelete = (brandIndex: number): void => {
    setBrands((prevBrands) =>
      prevBrands.filter((_brandItem, index) => index !== brandIndex),
    )
  }

  return (
    <div className="flex flex-col items-center gap-4">
      <div
        className="mx-auto flex w-full flex-wrap items-center gap-2"
        data-qa-id="sellerForm-brandsList"
      >
        {brands.map((brand, index) => (
          <div
            className="mb-2 flex w-full items-center gap-2"
            key={generateKey('brand', index)}
          >
            <Input
              className="flex-1 pr-10"
              onChange={(event) => {
                handleBrandChange(index, event.target.value)
              }}
              placeholder={intl.formatMessage({
                id: 'marketplacePartnerRegisterPage.brands.input.placeholder',
              })}
              value={brand}
            />
            <Button
              className="h-8 px-4 py-1 text-xs"
              data-qa-id="sellerForm-button-removeBrand"
              disabled={brands.length === 1}
              onClick={() => {
                handleDelete(index)
              }}
              type="button"
            >
              <FormattedMessage id="marketplacePartnerRegisterPage.brands.delete" />
            </Button>
          </div>
        ))}
      </div>
      <Button
        className="mt-2 w-fit"
        data-qa-id="sellerForm-button-addMoreBrands"
        onClick={handleAddMore}
        type="button"
      >
        <FormattedMessage id="marketplacePartnerRegisterPage.brands.addMore" />
      </Button>
    </div>
  )
}
